<template>
	<div class="row bg-lightGray">
		<!-- LeftBar -->
		<div :class="this.$route.name === 'sales/newSale' || this.$route.name === 'sales/edit' ? 'sidebar d-none d-xl-block p-0' : 'sidebar d-none d-lg-block p-0'">
			<Sidebar/>
		</div>
		<transition name="slide-fade">
			<Sidebar class="position-fixed" style="z-index: 99" v-show="$root.showSidebar"/>
		</transition>
		<transition name="fade">
			<div
				class="sidebar-overlay  bg-dark position-fixed"
				@click="$root.showSidebar = false"
				v-show="$root.showSidebar"
			>
			</div>
		</transition>
		<!-- Main -->
		<div class="col pb-4 px-0 px-md-3" style="width: auto" id="main">
			<div class="row">
				<div class='col px-0'>
					<AppBar class="d-sm-none"/>
					<MainMenu class="d-none d-sm-block px-3"/>
				</div>
			</div>
			<div class="grid grid-cols-12 gap-4">
				<!-- CenterContent -->
				<div :class="this.$route.name === 'sales/newSale' || this.$route.name === 'sales/edit' || this.$route.name !== 'login' ? 'col-span-12  md:col-span-12 lg:col-span-12 xl:col-span-9 mt-3' : isShowAdvice ? 'col-span-12 w-full mt-3' : 'col-span-12 xl:col-span-12 mt-3'">
					<b-overlay rounded="sm" :show="$root.showOverlay" opacity="0.4">
						<!-- just spacer to fix float menu on xs -->
						<div class="mt-5 row d-sm-none">
							<div class="mt-4 col"></div>
						</div>
						<transition name="fade">
							<flash-message transition="fade"></flash-message>
						</transition>
						<Alert variant="danger" v-if="$store.getters.getUserCompanyIsActive === false">
							{{ $t('plan.hasExpired') }}
						</Alert>
                        <Alert
                            variant="info"
                            v-if="leftTime"
                            class="border-0 text-gray-600 shadow text-red-600 mt-3">
                            {{$t('employee.jobEndTime', {time: parseInt((new Date("1970-01-01T" + jopEndTime) - new Date("1970-01-01T" + time)) / 60000) + 1})}}
                        </Alert>
						<Alert
							variant="danger"
							v-if="getUserCompany.plans.length !== 0 && calcCompanyAccessRestDay() <= 3 && calcCompanyAccessRestDay() > 0"
						>
							<TextTag v-if="$i18n.locale === 'uz'">
								Korxona aktivligiga {{ calcCompanyAccessRestDay() }} kun qoldi. Iltimos
								<router-link :to="$i18nHelper.getUrl('plans/compare')">to'lovni</router-link>
								o'z vaqtida amalga oshiring
							</TextTag>
							<TextTag v-else-if="$i18n.locale === 'ru'">
								До деактивизации компании осталось {{ calcCompanyAccessRestDay() }} дня. Пожалуйста,
								произведите
								<router-link :to="$i18nHelper.getUrl('plans/compare')">оплату</router-link>
								вовремя
							</TextTag>
							<TextTag v-else>
								There are {{ calcCompanyAccessRestDay() }} days left for the company's activity. Please
								<router-link :to="$i18nHelper.getUrl('plans/compare')">make the payment</router-link>
								on time
							</TextTag>
						</Alert>
						<slot/>

					</b-overlay>
				</div>

				<!-- RightBar -->
				<div
                    v-if="isShowAdvice"
					:class="this.$route.name === 'sales/newSale' || this.$route.name === 'sales/edit' || this.$route.name === 'login' ? 'col-span-5 lg:col-span-4 xl:col-span-3 d-none  bg-lightGray mt-3 rounded' : 'col-span-3 hidden xl:block bg-white px-3 mt-3 rounded shadow'"
				>
					<Advice v-if="$route.name !== null && this.$route.name !== 'sales/newSale' && this.$route.name !== 'sales/edit'" @hideAdvice="hideAdvice" />

                    <div
                        :class="this.$route.name === 'sales/newSale' || this.$route.name === 'sales/edit' ? 'shadow min-h-screen bg-white' : 'shadow'">
                        <JobTimeBanner
                            v-if="getUser.person.employeeInformation"
                            :is-sale-page="this.$route.name === 'sales/newSale' || this.$route.name === 'sales/edit'"/>

                        <!--  Pay Types  -->
                        <div v-if="this.$route.name === 'sales/newSale' || this.$route.name === 'sales/edit'" class="col-span-3 bg-white pb-3 rounded">
                            <div class="pt-3 font-bold text-fontColor pl-3">{{ $t('statistics.payTypes') }}
                                <img src="/images/left-right.png" alt="" class="float-right mr-3 h-6">
                            </div>
                            <div
                                class="mt-2 mx-2 gap-3 btn-group btn-group-toggle flex justify-content-around"
                                data-toggle="buttons">
                                <label
                                    @click="payType = 'cash'"
                                    class="flex justify-content-center bg-blue-100 pay-type rounded h-14 w-16 cursor-pointer btn btn-primary hover:bg-blue-200 active">
                                    <input type="radio" name="pay-type" v-model="payType" checked>
                                    <span
                                        :class="payType === 'cash' ? 'text-xs text-white font-bold position-absolute bottom-1' : 'text-xs text-fontColor font-bold position-absolute bottom-1'">
                                    {{ $t('statistics.categories.cash') }}
                                </span>
                                    <img src="/images/cash.png" alt="" class="h-6 mt-1">
                                </label>

                                <label
                                    @click="payType = 'bankCard'"
                                    class="flex justify-content-center bg-red-100 pay-type rounded h-14 w-16 cursor-pointer btn btn-primary hover:bg-red-200">
                                    <input type="radio" name="pay-type" v-model="payType">
                                    <span
                                        :class="payType === 'bankCard' ? 'text-xs text-white font-bold position-absolute bottom-1' : 'text-xs text-fontColor font-bold position-absolute bottom-1'">
                                    {{ $t('statistics.categories.bankCard') }}
                                </span>
                                    <img src="/images/bankCard.png" alt="" class="h-6 mt-1">
                                </label>

                                <label
                                    @click="payType = 'moneyTransfer'"
                                    class="flex justify-content-center bg-blue-100 pay-type rounded h-14 w-16 cursor-pointer btn btn-primary hover:bg-blue-200">
                                    <input type="radio" name="pay-type" v-model="payType">
                                    <span
                                        :class="payType === 'moneyTransfer' ? 'text-xs text-white font-bold position-absolute bottom-1' : 'text-xs text-fontColor font-bold position-absolute bottom-1'">
                                    {{ $t('statistics.categories.moneyTransfer') }}
                                </span>
                                    <img src="/images/moneyTransfer.png" alt="" class="h-7 mt-1">
                                </label>
                            </div>

                            <div
                                class="mt-2 mx-2 gap-3 btn-group btn-group-toggle flex justify-content-around"
                                data-toggle="buttons">
                                <label
                                    @click="isPayed = true"
                                    class="flex justify-content-center bg-blue-100 pay-type rounded h-14 w-16 cursor-pointer btn btn-primary hover:bg-blue-200 active">
                                    <input type="radio" name="payed-or-credit" v-model="isPayed" checked>
                                    <span
                                        :class="isPayed ? 'text-xs text-white font-bold position-absolute bottom-1' : 'text-xs text-fontColor font-bold position-absolute bottom-1'">
                                    {{ $t('payed') }}
                                </span>
                                    <img v-if="isPayed" src="/images/hand-shake.png" alt="" class="h-9">
                                    <img v-else src="/images/payed.png" alt="" class="h-5 mt-1">
                                </label>

                                <label
                                    @click="isPayed = false"
                                    class="flex justify-content-center bg-red-100 pay-type rounded h-14 w-16 cursor-pointer btn btn-primary hover:bg-red-200">
                                    <input type="radio" name="payed-or-credit" v-model="isPayed">
                                    <span
                                        :class="!isPayed ? 'text-xs text-white font-bold position-absolute bottom-1' : 'text-xs text-fontColor font-bold position-absolute bottom-1'">
                                    {{ $t('onCredit') }}
                                </span>
                                    <img src="/images/forDebt.png" alt="" class="h-7">
                                </label>

                                <label
                                    class="flex justify-content-center bg-blue-100 pay-type rounded h-14 w-16 cursor-pointer btn btn-primary hover:bg-blue-200 focus-within:bg-blue-100">
                                    <input type="checkbox" name="discount" v-model="hasDiscount" :disabled="isDisabledDiscountManually">
                                    <span
                                        :class="hasDiscount ? 'text-xs text-white font-bold position-absolute bottom-1' : 'text-xs text-fontColor font-bold position-absolute bottom-1'">
                                    {{ $t('sale.discount.title') }}
                                </span>
                                    <img src="/images/discount.png" alt="" class="h-8">
                                </label>
                            </div>
                        </div>

                        <!--  Tax Integration  -->
                        <div v-if="this.$route.name === 'sales/newSale' || this.$route.name === 'sales/edit'" class="flex justify-content-between align-items-center px-2 bg-white rounded my-2">
                            <div class="text-xs font-bold">{{ $t('sale.integration') }}</div>
                            <div class="">
                                <b-form-checkbox
                                    v-b-tooltip="$t('sale.integrationTitle')"
                                    inline
                                    switch
                                    size="lg"
                                    class="mr-n2"
                                    v-model="isNeedIntegration"
                                    @change="changeIntegrationState"
                                    :value="true"
                                    :unchecked-value="false"
                                />
                            </div>
                        </div>

                        <!--  Sale information  -->
                        <div v-if="this.$route.name === 'sales/newSale' || this.$route.name === 'sales/edit'" class="col-span-3 bg-white pb-3 rounded">
                            <div class="text-fontColor font-bold ml-3 pt-2">{{ $t('sale.information') }}</div>
                            <div class="flex justify-content-between px-3 mt-2">
                                <div class="text-gray-500">{{ $t('product.count') }}</div>
                                <div v-if="productAmount" class="text-gray-500 font-bold">{{ productAmount }} {{ $t('pcs') }}</div>
                            </div>
                            <div class="flex justify-content-between px-3" v-if="getUserCompany.isTaxInPrice">
                                <div class="text-gray-500">{{ $t('sale.totalSum') }}</div>
                                <div v-if="getCurrencyByShortName(currentCurrencyShortName) && totalPrice" class="text-gray-500 font-bold">
                                    {{ showCurrencyById(getCurrencyByShortName(currentCurrencyShortName).id, totalPrice - cashbackAmount) }}
                                </div>
                            </div>
                            <div class="flex justify-content-between px-3" v-else>
                                <div class="text-gray-500">{{ $t('sale.totalSum') }}</div>
                                <div v-if="getCurrencyByShortName(currentCurrencyShortName) && totalPrice" class="text-gray-500 font-bold">
                                    {{ showCurrencyById(getCurrencyByShortName(currentCurrencyShortName).id, totalPrice) }}
                                </div>
                            </div>

                            <div v-if="taxAmount && getCurrencyByShortName(currentCurrencyShortName)" class="flex justify-content-between px-3">
                                <div class="text-green-500">{{ $t('sale.tax.title') }}</div>
                                <div v-if="getCurrencyByShortName(currentCurrencyShortName)" class="text-green-500 font-bold">
                                    {{ showCurrencyById(getCurrencyByShortName(currentCurrencyShortName).id, taxAmount) }}
                                </div>
                            </div>
                            <div v-if="this.getUserCompany.isTaxInPrice && getCurrencyByShortName(currentCurrencyShortName)" class="flex justify-content-between px-3">
                                <div class="text-green-500">{{ $t('sale.tax.inPriceOnCheck') }} {{ $t('sale.tax.title') }}</div>
                                <div v-if="!isNaN(taxPercentAmount)" class="text-green-500 font-bold">
                                    {{ showCurrencyById(getCurrencyByShortName(currentCurrencyShortName).id, taxPercentAmount) }}
                                </div>
                                <div v-else class="text-green-500 font-bold">
                                    {{ showCurrencyById(getCurrencyByShortName(currentCurrencyShortName).id, 0) }}
                                </div>
                            </div>

                            <div v-if="discountPercent" class="flex justify-content-between px-3">
                                <div class="text-green-500">{{ $t('sale.discount.title') }}</div>
                                <div class="text-green-500 font-bold">{{ discountPercent }}%</div>
                            </div>
                            <div v-if="discountPercent > 0" class="flex justify-content-end px-3">
                                <div v-if="getCurrencyByShortName(currentCurrencyShortName)" class="text-green-500 font-bold">
                                    {{ showCurrencyById(getCurrencyByShortName(currentCurrencyShortName).id, discountPercent * totalPrice / 100) }}
                                </div>
                            </div>
                            <div v-if="bonusSumAmount > 0" class="flex justify-content-between px-3">
                                <div class="text-green-500">{{ $t('sale.discount.title') }}</div>
                                <div v-if="getCurrencyByShortName(currentCurrencyShortName)" class="text-green-500 font-bold">
                                    {{ showCurrencyById(getCurrencyByShortName(currentCurrencyShortName).id, bonusSumAmount) }}
                                </div>
                            </div>


                            <HrRow class="mx-1"/>

                            <div class="flex justify-content-between px-3" v-if="cashbackAmount">
                                <div class="text-gray-500">{{ $t('customer.cashback.payFromCashback') }}</div>
                                <div v-if="totalPrice && getCurrencyByShortName(currentCurrencyShortName)" class="text-gray-500 font-bold">
                                    {{
                                        showCurrencyById(getCurrencyByShortName(currentCurrencyShortName).id, cashbackAmount)
                                    }}
                                </div>
                            </div>

                            <div class="flex justify-content-between px-3">
                                <div class="text-gray-500">{{ $t('productPurchase.paymentAmount') }}</div>
                                <div v-if="totalPrice && getCurrencyByShortName(currentCurrencyShortName)" class="text-gray-500 font-bold">
                                    {{
                                        showCurrencyById(getCurrencyByShortName(currentCurrencyShortName).id, payedAmount)
                                    }}
                                </div>
                            </div>
                            <div
                                v-if="Math.round(parseFloat(finalPrice) - (parseFloat(payedAmount) + parseFloat(cashbackAmount))) > 0"
                                class="flex justify-content-between px-3">
                                <div class="text-red-400">{{ $t('debt') }}</div>
                                <div v-if="getCurrencyByShortName(currentCurrencyShortName)" class="text-red-400 font-bold">
                                    {{
                                        showCurrencyById(this.getCurrencyByShortName(currentCurrencyShortName).id, (parseFloat(finalPrice) - parseFloat(payedAmount) - parseFloat(cashbackAmount)))
                                    }}
                                </div>
                            </div>
                            <div
                                v-else-if="Math.round(parseFloat(finalPrice)) < Math.round(parseFloat(payedAmount))"
                                class="flex justify-content-between px-3">
                                <div class="text-blue-400">{{ $t('sale.oddMoney') }}</div>
                                <div v-if="getCurrencyByShortName(currentCurrencyShortName)" class="text-blue-400 font-bold">
                                    {{
                                        showCurrencyById(this.getCurrencyByShortName(currentCurrencyShortName).id, payedAmount - parseFloat(finalPrice))
                                    }}
                                </div>
                            </div>

                            <div class="position-relative pl-0 mt-4 mx-3">
                                <div
                                    class="font-bold text-sm bg-white px-1 text-red-400 z-30 position-absolute bottom-9 ml-2">
                                    {{ $t('productPurchase.paymentAmount') }}
                                </div>
                                <b-form-input
                                    type="number"
                                    class="h-11 border-red-400"
                                    v-model="payedAmount"
                                    @input="changePayedAmount"
                                />

                            </div>

                            <div class="mx-3 mt-3">
                                <button
                                    @click="makeDraftSale"
                                    class="bg-gray-300 text-gray-500 font-bold border-0 rounded w-full h-11 hover:bg-gray-400 focus:outline-none">
                                    {{ $t('sale.draft') }}
                                </button>
                            </div>

                          <div class="mx-3 mt-3" v-if="isShowCashbackButton">
                            <button
                                @click="payFromCashbackModal"
                                class="bg-red-600 text-white font-bold border-0 rounded w-full h-11 hover:bg-red-500 focus:outline-none">
                                {{ $t('customer.cashback.payFromCashback') }}
                            </button>
                          </div>

                            <div class="mx-3 mt-3">
                                <button
                                    ref="saleBtn"
                                    @click="makeSale"
                                    class="bg-main text-white font-bold border-0 rounded w-full h-11 hover:bg-hoverMain focus:outline-none">
                                    {{ $t('sale.confirmed') }}
                                </button>
                            </div>
                        </div>

                        <!--  Additional info to receipt  -->
                        <div v-if="this.$route.name === 'sales/newSale' || this.$route.name === 'sales/edit'" class="col-span-3 bg-white pb-3 rounded">
                            <div class="mx-3">
                                <div class="text-xs font-bold">{{ $t('printView.addInfo') }}</div>
                                <textarea rows="4" @input="addReceiptInfo" class="rounded w-full" v-model="additionalInfo"/>
                            </div>
                        </div>
                    </div>

				</div>
			</div>
		</div>
		<Modal
			:text="modalText"
			id="modal_show1"
		/>

	</div>
</template>

<script>
import Sidebar from "@/components/Sidebar"
import AppBar from "@/components/AppBar";
import Alert from "@/components/html/Alert";
import MainMenu from "@/components/MainMenu";
import Advice from "@/components/Advice";
import TextTag from "../components/html/TextTag";
import {mapActions, mapGetters} from "vuex";
import Modal from "@/components/html/Modal.vue";
import JobTimeBanner from "@/components/JobTimeBanner.vue";
import HrRow from "@/components/html/HrRow.vue";
import currencyFormatMixin from "@/mixin/currencyFormatMixin";

export default {
	name: "DefaultLayout",
    components: {
        HrRow,
        JobTimeBanner,
        Modal,
        Advice,
        Alert,
        AppBar,
        Sidebar,
        MainMenu,
        TextTag
    },
	mixins: [currencyFormatMixin],
    data() {
        return {
            modalText: '',
            totalPrice: null,
            finalPrice: null,
            payedAmount: null,
            cashbackAmount: null,
            taxAmount: null,
            taxPercent: null,
            taxPercentAmount: null,
            productAmount: null,
            payType: 'cash',
            isPayed: true,
            hasDiscount: false,
            isNeedIntegration: JSON.parse(localStorage.getItem('isNeedIntegration')),
            discountPercent: null,
            bonusPercentAmount: null,
            bonusSumAmount: null,
            isDisabledDiscountManually: false,
            additionalInfo: null,
            isShowAdvice: true,
            isShowCashbackButton: false,
            interval: null,
            time: null,
            date: null,
            jopEndTime: null
        }
    },
	computed: {
        leftTime() {
            return (parseInt((new Date("1970-01-01T" + this.jopEndTime) - new Date("1970-01-01T" + this.time)) / 60000) + 1) <= 15 &&
                (parseInt((new Date("1970-01-01T" + this.jopEndTime) - new Date("1970-01-01T" + this.time)) / 60000) + 1) > 0
        },
		...mapGetters([
			'getUserCompany',
			'getUser',
			'getEmployeeAtWork',
			'getEmployeeAtWorks',
			'getTotalPrice',
			'getPayedAmount',
			'getTaxAmount',
			'getDiscountPercent',
			'getBonusPercentAmount',
			'getProductAmount',
			'getPayType',
			'getIsPayed',
			'getFinalPrice',
			'getBonusSumAmount',
			'getIsDisabledManuallyDiscount',
			'getTaxPercent',
			'getTaxPercentAmount',
            'getIntegrationState',
            'getCurrentCurrencyName',
            'getCashbackAmount',
            'getCustomerId',
            'findCustomerById'
		]),
		exceptionPageList() {
			return this.$route.name !== 'statistics/show'
				&& this.$route.name !== 'statistics/exDebtShow'
				&& this.$route.name !== 'statistics/debtShow'
				&& this.$route.name !== 'statistics/employeeShow'
				&& this.$route.name !== 'products/addMany'
				&& this.$route.name !== 'customers/edit'
				&& this.$route.name !== 'customers/add'
				&& this.$route.name !== 'customers'
				&& this.$route.name !== 'customers/view'
				&& this.$route.name !== 'products-in-warehouses'
				&& this.$route.name !== 'products/purchaseFew'
				&& this.$route.name !== 'products-in-warehouse'
				&& this.$route.name !== 'products-in-warehouses/page'
				&& this.$route.name !== 'products/purchase'
				&& this.$route.name !== 'statistics/sale'
				&& this.$route.name !== 'statistics/product'
				&& this.$route.name !== 'statistics/product/page'
				&& this.$route.name !== 'statistics/purchase'
				&& this.$route.name !== 'statistics/employee'
				&& this.$route.name !== 'statistics/customer'
				&& this.$route.name !== 'statistics/supplier'
				&& this.$route.name !== 'sales/discounts'
				&& this.$route.name !== 'sales/discounts/add'
				&& this.$route.name !== 'sales/discounts/edit'
				&& this.$route.name !== 'auto-order'
				&& this.$route.name !== 'auto-order/list'
				&& this.$route.name !== 'inventories'
				&& this.$route.name !== 'inventory'
				&& this.$route.name !== 'inventory/page'
				&& this.$route.name !== 'inventory-make'
				&& this.$route.name !== 'inventory-equalization'
				&& this.$route.name !== 'product/modified-products'
				&& this.$route.name !== 'product/modify/page'
				&& this.$route.name !== 'product/make-modify'
				&& this.$route.name !== 'product/modify'
				&& this.$route.name !== 'incomeAndOutcome'
				&& this.$route.name !== 'incomeAndOutcomes'
				&& this.$route.name !== 'incomeAndOutcomeCategory'
				&& this.$route.name !== 'incomeAndOutcomeCategories'
				&& this.$route.name !== 'incomeAndOutcomeCategory/add'
				&& this.$route.name !== 'incomeAndOutcomeCategory/edit'
				&& this.$route.name !== 'companyCount'
				&& this.$route.name !== 'companyCounts'
				&& this.$route.name !== 'companyCount/add'
				&& this.$route.name !== 'companyCount/edit'
				&& this.$route.name !== 'product/modify'
				&& this.$route.name !== 'product/modify'
				&& this.$route.name !== 'employees/add'
				&& this.$route.name !== 'employees/edit'
				&& this.$route.name !== 'employees/page'
				&& this.$route.name !== 'employees'
				&& this.$route.name !== 'employee'
				&& this.$route.name !== 'employees_at_work'
				&& this.$route.name !== 'employees/kpi/add'
				&& this.$route.name !== 'employees/kpi/list'
				&& this.$route.name !== 'employees/kpi/list/page'
				&& this.$route.name !== 'employees/kpi/edit'
				&& this.$route.name !== 'employees/kpi/employees/page'
				&& this.$route.name !== 'employees/kpi/employees'
				&& this.$route.name !== 'employees_salary'
				&& this.$route.name !== 'report'
		},
		getWeekDayNumber() {
			return new Date().getDay()
		},
        hasAvailableCommunicator() {
            return this.getUserCompany.legalAddress !== null && this.getUserCompany.tin !== null
        }
	},
	methods: {
		...mapActions([
			'putEmployeeAtWork',
			'fetchUser',
			'fetchEmployeeAtWork',
			'fetchEmployeeAtWorks',
			'setPayedAmount',
			'setPayType',
			'setIsPayed',
			'setHasDiscount',
            'setIsNeedIntegration',
            'setIsMakeSale',
            'setIntegrationState',
            'setAdditionalInfoReceipt',
            'setIsMakeDraftSale',
            'setCashbackAmount'
		]),
        changeIntegrationState() {
            localStorage.setItem('isNeedIntegration', JSON.stringify(this.isNeedIntegration))
        },
        realtimeClock() {
            // update the time every second
            this.interval = setInterval(() => {
                // Concise way to format time according to system locale.
                // In this case it returns "17:25:00"
                this.time = Intl.DateTimeFormat(navigator.language, {
                    hour12: false,
                    hour: '2-digit',
                    minute: '2-digit',
                    second: '2-digit',
                }).format()
            }, 1000)
        },
        hideAdvice() {
            this.isShowAdvice = false
        },
        keyDownHandler(e) {
            if (e.key === 'Enter') {
                this.$refs.saleBtn.click()
            }
        },
		calcTaxAmount(amount, percent) {
			return amount * percent / 100
		},
		calcCompanyAccessRestDay() {
			const time = new Date(this.getUserCompany.plans[this.getUserCompany.plans.length - 1].until) - Date.now();
			return Math.ceil(Math.ceil((time / 1000) / (3600 * 24)));
		},
		finish(endTime) {
			let currentTime = new Date()
			let times = endTime.split(':')

			let employeeEndTime = new Date(currentTime.getFullYear(), currentTime.getMonth(), currentTime.getDate(), +times[0], +times[1])

			if (currentTime > employeeEndTime) {
				this.finishWork()
			} else {
				this.$bvModal.show('finish_work')
			}

		},
		finishWork() {
			this.$root.showOverlay = true

			let data = {}
			data.id = this.getEmployeeAtWork.id
			data.endedAt = this.getCurrentTime()
			data.hasAtWork = false

			this
				.putEmployeeAtWork(data)
				.then(() => {
					this.$root.showOverlay = false
					this.$i18nHelper.toUrl('logout');
				})
				.catch((reason) => {
					this.$root.showOverlay = false
					this.modalText = reason
					this.$bvModal.show('modal_show1')
				})
		},
		getCurrentTime() {
			let d = new Date()

			return this.addZero(d.getHours()) + ':' + this.addZero(d.getMinutes())
		},
		addZero(val) {
			return val < 10 ? '0' + val : val;
		},
		changePayedAmount() {
			this.setPayedAmount(this.payedAmount)
		},
        makeDraftSale() {
            this.setIsMakeDraftSale(true)
        },
        makeSale() {
            if (this.totalPrice) {
                this.setIsMakeSale(true)
            }
        },
        addReceiptInfo() {
            this.setAdditionalInfoReceipt(this.additionalInfo)
        },
        payFromCashbackModal() {
            if (this.cashbackAmount !== null) {
                this.payedAmount += +this.cashbackAmount
                this.cashbackAmount = null
                this.setCashbackAmount('0')
            }


            if (this.totalPrice > 0) {
                this.$bvModal.show('pay-from-cashback-modal')
            }
        }
	},
	watch: {
        'getUser.person.employeeInformation'() {
            if(this.getUser.person.employeeInformation.endTime !== null) {
                this.jopEndTime = this.getUser.person.employeeInformation.endTime
            }
        },
		'payType'() {
			this.setPayType(this.payType)
		},
		'isPayed'() {
			this.setIsPayed(this.isPayed)
		},
		'hasDiscount'() {
			this.setHasDiscount(this.hasDiscount)
		},
        'isNeedIntegration'() {
            this.setIsNeedIntegration(this.isNeedIntegration)
            this.setIntegrationState(this.isNeedIntegration)
        },
        '$route': function () {
            if (this.$route.name === 'sales/newSale' || this.$route.name === 'sales/edit') {
                this.isShowAdvice = true
            }
        },
        getCurrentCurrencyName: {
            deep: true,
            handler: function (newVal) {
                this.currentCurrencyShortName = newVal
            }
        },
		getPayedAmount: {
			deep: true,
			handler: function (newVal) {
				this.payedAmount = newVal

                if (this.cashbackAmount && this.isPayed) {
                    this.payedAmount -= this.cashbackAmount
                }
			}
		},
        getCustomerId: {
            deep: true,
            handler: function (newVal) {
               if (this.findCustomerById(newVal).hasCard) {
                   this.isShowCashbackButton = true
               } else {
                   this.isShowCashbackButton = false
               }
            }
        },
        getCashbackAmount: {
            deep: true,
            handler: function (newVal) {
                this.cashbackAmount = newVal
                this.payedAmount -= this.cashbackAmount
            }
        },
		getDiscountPercent: {
			deep: true,
			handler: function (newVal) {
				this.discountPercent = newVal
			}
		},
		getTotalPrice: {
			deep: true,
			handler: function (newVal) {
				this.totalPrice = newVal
			}
		},
		getTaxAmount: {
			deep: true,
			handler: function (newVal) {
				this.taxAmount = newVal
			}
		},
		getTaxPercent: {
			deep: true,
			handler: function (newVal) {
				this.taxPercent = newVal
			}
		},
		getTaxPercentAmount: {
			deep: true,
			handler: function (newVal) {
				this.taxPercentAmount = newVal
			}
		},
		getProductAmount: {
			deep: true,
			handler: function (newVal) {
				this.productAmount = newVal
			}
		},
		getFinalPrice: {
			deep: true,
			handler: function (newVal) {
				this.finalPrice = newVal
			}
		},
		getBonusSumAmount: {
			deep: true,
			handler: function (newVal) {
				this.bonusSumAmount = newVal
			}
		},
		getIsDisabledManuallyDiscount: {
			deep: true,
			handler: function (newVal) {
				this.isDisabledDiscountManually = newVal
			}
		}
	},
	mounted() {
        if (this.getUser.person.employeeInformation !== null) {
            this.fetchEmployeeAtWorks()
            this.fetchEmployeeAtWork()
            this.isNeedIntegration = this.getIntegrationState
        }
	},
    created() {
        this.realtimeClock()
    },
    destroyed() {
        window.removeEventListener('keydown', this.keyDownHandler)
    },
}
</script>

<style scoped>

.pay-type {
	border: none !important;
	outline: none !important;
	box-shadow: none !important;
}


.sidebar-overlay {
	background-color: red;
  inset: 0;
	opacity: 0.5;
	z-index: 98;
}

.work-card {
	height: 120px;
	text-align: center;
}

.line {
	border-top: 1px solid rgb(111, 66, 193);
	margin-top: 0;
	width: 90%;
}

.my-btn {
	background-color: rgba(245, 97, 171, 0.91);
	border: none;
	font-weight: 600;
}

.my-btn:hover {
	background-color: red;
	color: white;
}

.row {
	min-width: 230px;
}

/* slide-fade */
.slide-fade-enter-active {
	transition: all .3s ease;
}

.slide-fade-leave-active {
	transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}

.slide-fade-enter, .slide-fade-leave-to {
	transform: translateX(-50px);
	opacity: 0;
}

</style>
